export const MarketingCompensatedDiscountsProductsGridPluginSettings: IPluginSettings = {
    name: 'Товары компенсируемых скидок',
    mnemocode: 'marketing_compensated_discounts_products_plugin',
    permission: 'MarketingEventsProducts',
    columns: (() => {
        let index = 0;
        return [
            {
                order: index++,
                propertyName: 'idGlobal',
                propertyType: 'string',
                displayName: 'idGlobal',
                visibility: false,
                width: 300
            },
            {
                order: index++,
                propertyName: 'IdMarketingCompensatedDiscountGlobal',
                propertyType: 'string',
                displayName: 'ID компенсируемой скидки',
                visibility: false,
                width: 300
            },            
            {
                order: index++,
                propertyName: 'idGoodsGlobal',
                propertyType: 'string',
                displayName: 'GUID товара',
                visibility: false,
                width: 300
            },
            {
                order: index++,
                propertyName: 'goodsName',
                propertyType: 'string',
                displayName: 'Товар',
                visibility: true,
                width: 250
            },            
            {
                order: index++,
                propertyName: 'producerName',
                propertyType: 'string',
                displayName: 'Производитель',
                visibility: true,
                width: 250
            },            
            {
                order: index++,
                propertyName: 'legalEntityName',
                propertyType: 'string',
                displayName: 'Юридическое лицо',
                visibility: true,
                width: 300
            },            
            {
                order: index++,
                propertyName: 'marketingDepartmentName',
                propertyType: 'string',
                displayName: 'Подразделение',
                visibility: true,
                width: 300
            },           
            {
                order: index++,
                propertyName: 'contractorName',
                propertyType: 'string',
                displayName: 'Аптека',
                visibility: true,
                width: 300
            },           
            {
                order: index++,
                propertyName: 'discount',
                propertyType: 'number',
                displayName: 'Скидка',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'maxPackAmount',
                propertyType: 'number',
                displayName: 'Максимальное количество упаковок',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'dateCreated',
                propertyType: 'datetime',
                displayName: 'Дата создания',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateModified',
                propertyType: 'datetime',
                displayName: 'Дата изменения',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateDeleted',
                propertyType: 'datetime',
                displayName: 'Дата удаления',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'deleted',
                propertyType: 'boolean',
                displayName: 'Удален',
                visibility: false,
                width: 100
            }
        ];
    })()
};